import store from '@/store'

export default { 
    async bind(el, binding, vnode) {
        // 如果绑定值为 false，则从父节点中移除元素
        const vm = await el
        const permIds = await binding.value
        let isLogin = await store.getters.isLogin
        let customerType = await store.getters.userInfo.customerType
        if (!binding.value) return
        if (permIds.indexOf(customerType)==-1 || !isLogin){
            vm.parentNode && vm.parentNode.removeChild(vm) 
        }
    }

}